(function () {
  'use strict';
  if (window.sgBfVipUnlock) { window.sgBfVipUnlock.scan(document); return; }
  var instances = new Map(), activeRegistrationRoot = null;
  // Shared anonymous display-registration state. Login is fresh Liquid state only.
  var campaigns = new Map(), nativeSources = new WeakSet();
  var campaignPrefix = 'sg-member-display:v2:';
  function safeGet(key) { try { return localStorage.getItem(key); } catch (_) { return null; } }
  function safeSet(key, value) { try { localStorage.setItem(key, value); } catch (_) { /* Page state still works. */ } }
  function safeRemove(key) { try { localStorage.removeItem(key); } catch (_) { /* Storage may be blocked. */ } }
  function validRecord(raw, campaign) {
    try {
      var record = JSON.parse(raw), now = Date.now();
      if (!record || record.version !== 2 || record.campaign !== campaign || !['native', 'klaviyo', 'legacy'].includes(record.source)) return null;
      if (!Number.isFinite(record.issued) || !Number.isFinite(record.expires) || record.issued <= 0 || record.issued > now || record.expires <= now || record.expires <= record.issued || record.expires - record.issued > 90 * 86400000) return null;
      return { version: 2, source: record.source, issued: record.issued, expires: record.expires, campaign: campaign };
    } catch (_) { return null; }
  }
  function emit(campaign) {
    window.dispatchEvent(new CustomEvent('sg:member-display-change', { detail: { campaign: campaign } }));
  }
  function scheduleCampaign(state) {
    clearTimeout(state.timer);
    if (!state.record) return;
    state.timer = setTimeout(function () {
      if (state.record && state.record.expires > Date.now()) scheduleCampaign(state);
      else { state.record = null; emit(state.campaign); }
    }, Math.min(2147483647, Math.max(0, state.record.expires - Date.now())));
  }
  function campaignState(campaign) {
    campaign = campaign || 'bf-2026-machine';
    if (!campaigns.has(campaign)) {
      var state = { campaign: campaign, record: validRecord(safeGet(campaignPrefix + encodeURIComponent(campaign)), campaign), timer: 0 };
      campaigns.set(campaign, state); scheduleCampaign(state);
    }
    return campaigns.get(campaign);
  }
  function register(campaign, source, days, migrated) {
    var state = campaignState(campaign), now = Date.now();
    var record = migrated || { version: 2, source: source, issued: now, expires: now + Math.min(90, Math.max(1, Number(days) || 30)) * 86400000, campaign: state.campaign };
    state.record = record; safeSet(campaignPrefix + encodeURIComponent(state.campaign), JSON.stringify(record));
    safeRemove('sg-bf-email-registered'); scheduleCampaign(state); emit(state.campaign);
    return record;
  }
  function nativeSuccess(scope) {
    var nodes = [];
    if (scope.matches && scope.matches('[data-sg-email-registration-success]')) nodes.push(scope);
    if (scope.querySelectorAll) nodes = nodes.concat(Array.from(scope.querySelectorAll('[data-sg-email-registration-success]')));
    nodes.forEach(function (node) {
      if (nativeSources.has(node)) return;
      nativeSources.add(node);
      register(node.dataset.sgMemberCampaign || node.closest('[data-sg-member-campaign]')?.dataset.sgMemberCampaign || 'bf-2026-machine', 'native', node.dataset.sgMemberDays || 30);
    });
  }
  function migrate(root) {
    var data = root.dataset, campaign = data.campaign || 'bf-2026-machine', state = campaignState(campaign);
    var key = campaignPrefix + encodeURIComponent(campaign);
    // Existing (even expired) v2 metadata prevents renewing a stale v1/legacy marker.
    if (state.record || safeGet(key) !== null) return;
    var oldKey = 'sg-vip-unlock:v1:' + [campaign, (data.formId || '').trim(), data.product, data.variant].map(encodeURIComponent).join(':');
    var raw = safeGet(oldKey), old;
    try { old = JSON.parse(raw); } catch (_) { old = null; }
    var now = Date.now();
    if (old && old.version === 1 && old.unlocked === true && Number.isFinite(old.issued) && Number.isFinite(old.expires) && old.issued > 0 && old.issued <= now && old.expires > now && old.expires > old.issued && old.expires - old.issued <= 90 * 86400000) {
      register(campaign, 'klaviyo', data.ttlDays, { version: 2, source: 'klaviyo', issued: old.issued, expires: old.expires, campaign: campaign });
      safeRemove(oldKey);
    } else if (safeGet('sg-bf-email-registered') === 'true') register(campaign, 'legacy', data.ttlDays);
  }
  window.addEventListener('storage', function (event) {
    campaigns.forEach(function (state, campaign) {
      var key = campaignPrefix + encodeURIComponent(campaign);
      if (event.key !== null && event.key !== key) return;
      state.record = validRecord(event.newValue, campaign);
      if (event.key === null) state.record = null;
      scheduleCampaign(state); emit(campaign);
    });
  });
  window.addEventListener('sg:member-native-source-ready', function () { nativeSuccess(document); });
  window.sgBfMemberDisplay = { scan: nativeSuccess, isRegistered: function (campaign) { var state = campaignState(campaign); return !!(state.record && state.record.expires > Date.now()); } };
  var nativeObserver = new MutationObserver(function (changes) { changes.forEach(function (change) { change.addedNodes.forEach(function (node) { if (node.nodeType === 1) nativeSuccess(node); }); }); });
  nativeObserver.observe(document.documentElement, { childList: true, subtree: true });

  function init(root) {
    if (instances.has(root)) return;
    var data = root.dataset, id = (data.formId || '').trim();
    var valid = /^[A-Za-z0-9]{6}$/.test(id);
    var price = root.querySelector('[data-sg-vip-unlock-price]');
    var label = root.querySelector('[data-sg-vip-unlock-label]');
    var region = root.querySelector('[data-sg-vip-unlock-region]');
    var button = root.querySelector('[data-sg-vip-unlock-open]');
    var status = root.querySelector('[data-sg-vip-unlock-status]');
    var dialog = root.querySelector('[data-sg-vip-unlock-dialog]');
    var help = root.querySelector('[data-sg-vip-unlock-help]');
    var retry = root.querySelector('[data-sg-vip-unlock-retry]');
    var host = root.querySelector('[data-sg-vip-unlock-embed]');
    if (!price || !label) return;
    var campaign = data.campaign || 'bf-2026-machine';
    var days = Math.min(90, Math.max(1, Number(data.ttlDays) || 30));
    var unlocked = false, timer = 0, destroyed = false;
    var bodyOverflow = null, opener = null, observer = null;
    campaignState(campaign); migrate(root);
    function stopWait() { clearTimeout(timer); timer = 0; }
    function closeDialog(restore) {
      if (!dialog || !dialog.open) return;
      dialog.close();
      if (bodyOverflow !== null) { document.body.style.overflow = bodyOverflow; bodyOverflow = null; }
      if (restore && opener && opener.isConnected) opener.focus({ preventScroll: true });
    }
    function display() {
      unlocked = data.loggedIn === 'true' || window.sgBfMemberDisplay.isRegistered(campaign);
      root.dataset.vipUnlocked = String(unlocked);
      price.textContent = unlocked ? data.vipPrice : data.normalPrice;
      label.textContent = unlocked ? data.vipLabel : data.normalLabel;
      if (button) button.hidden = !valid || unlocked;
      if (status) status.textContent = unlocked ? data.success : '';
    }
    function finish(locate) {
      stopWait();
      closeDialog(false);
      display();
      if (locate && region) {
        region.style.scrollMarginTop = 'calc(var(--header-height, 90px) + 40px)';
        region.focus({ preventScroll: true });
        region.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
    }
    function waiting() {
      stopWait();
      if (help) help.textContent = '';
      if (retry) retry.hidden = true;
      if (status) status.textContent = '';
      timer = setTimeout(function () {
        timer = 0;
        if (unlocked || destroyed) return;
        // Open/embedOpen are the provider's supported acknowledgement of display.
        if (dialog && dialog.open) {
          if (help) help.textContent = data.failure;
          if (retry) retry.hidden = false;
        } else if (status) status.textContent = data.failure;
      }, 10000);
    }
    function open() {
      if (!valid || unlocked) return;
      activeRegistrationRoot = root;
      waiting();
      if (data.mode === 'embed' && dialog) {
        opener = document.activeElement;
        if (!dialog.open) {
          dialog.showModal();
          bodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
        if (host && !observer && 'MutationObserver' in window) {
          observer = new MutationObserver(function () {
            // Observe hydration without coupling to undocumented Klaviyo selectors.
            if (host.querySelector('input,iframe,button')) { stopWait(); if (help) help.textContent = ''; if (retry) retry.hidden = true; }
          });
          observer.observe(host, { childList: true, subtree: true });
        }
        if (host && host.querySelector('input,iframe,button')) stopWait();
      } else {
        try {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', id]);
        } catch (_) { stopWait(); if (status) status.textContent = data.failure; }
      }
    }
    function providerEvent(event) {
      var detail = event.detail;
      if (!valid || !detail || detail.formId !== id) return;
      if (unlocked) return;
      if (detail.type === 'open' || detail.type === 'embedOpen') { stopWait(); if (status) status.textContent = ''; return; }
      if (detail.type === 'close') { stopWait(); if (activeRegistrationRoot === root) activeRegistrationRoot = null; return; }
      if (detail.type !== 'submit' || unlocked) return;
      // The email is inspected transiently only. Never persist or log event data.
      if (!detail.metaData || ![detail.metaData.email, detail.metaData.$email].some(function (email) { return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()); })) return;
      register(campaign, 'klaviyo', days);
      if (activeRegistrationRoot === root) finish(true);
    }
    function memberChanged(event) {
      if (!event.detail || event.detail.campaign !== campaign) return;
      var wasUnlocked = unlocked;
      display();
      if (!wasUnlocked && unlocked) { stopWait(); closeDialog(false); if (activeRegistrationRoot === root) finish(true); }
    }
    function click(event) {
      if (event.target.closest('[data-sg-vip-unlock-open]') || event.target.closest('[data-sg-vip-unlock-retry]')) open();
      else if (event.target.closest('[data-sg-vip-unlock-close]')) { stopWait(); closeDialog(true); }
      else if (dialog && event.target === dialog) {
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) { stopWait(); closeDialog(true); }
      }
    }
    function cancelled(event) { event.preventDefault(); stopWait(); closeDialog(true); }
    function closed() { if (!dialog.open && bodyOverflow !== null) { document.body.style.overflow = bodyOverflow; bodyOverflow = null; } }
    root.addEventListener('click', click);
    window.addEventListener('klaviyoForms', providerEvent);
    window.addEventListener('sg:member-display-change', memberChanged);
    if (dialog) { dialog.addEventListener('cancel', cancelled); dialog.addEventListener('close', closed); }
    display();
    instances.set(root, function () {
      destroyed = true; stopWait(); closeDialog(false);
      if (activeRegistrationRoot === root) activeRegistrationRoot = null;
      if (observer) observer.disconnect();
      root.removeEventListener('click', click);
      window.removeEventListener('klaviyoForms', providerEvent); window.removeEventListener('sg:member-display-change', memberChanged);
      if (dialog) { dialog.removeEventListener('cancel', cancelled); dialog.removeEventListener('close', closed); }
    });
  }
  function scan(scope) { nativeSuccess(scope); if (scope.matches && scope.matches('[data-sg-vip-unlock]')) init(scope); scope.querySelectorAll('[data-sg-vip-unlock]').forEach(init); }
  window.sgBfVipUnlock = { scan: scan, instanceCount: function () { return instances.size; } };
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); instances.delete(root); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
})();
